<template>
  <div class="qai-section">
    <div class="qai-section__header mb-4">
      <div class="d-flex align-center">
        <div class="qai-section__accent-bar"></div>
        <div>
          <div class="text-h6 font-weight-semibold qai-section__title">{{ section.Name }}</div>
          <div v-if="section.Description" class="text-caption grey--text text--darken-1 mt-1">
            {{ section.Description }}
          </div>
        </div>
      </div>
      <v-divider class="mt-3" />
    </div>
    <div class="qai-section__body">
      <QAISettingsProperty v-for="prop in section.Properties" :key="prop.Name" :definition="prop"
        :value="getPropertyValue(prop.Name)" @input="setPropertyValue(prop.Name, $event)" />
    </div>
  </div>
</template>

<script>
import QAISettingsProperty from "./QAISettingsProperty.vue";

/**
 * Maps a Definition Section name to the corresponding key in Configuration.
 * The Definition section names are "Agents", "Providers", "Channels", etc.
 * The Configuration top-level keys are "agents", "providers", "channels", etc.
 */
const SECTION_KEY_MAP = {
  Agents: "agents",
  Providers: "providers",
  Channels: "channels",
};

export default {
  name: "QAISettingsSection",
  components: { QAISettingsProperty },
  props: {
    section: { type: Object, required: true },
    configuration: { type: Object, required: true },
  },

  data() {
    return {
      panel: undefined,
    };
  },

  computed: {
    configKey() {
      return SECTION_KEY_MAP[this.section.Name] || this.section.Name.toLowerCase();
    },
    sectionValue() {
      return this.configuration[this.configKey];
    },
  },

  methods: {
    getPropertyValue(name) {
      if (!this.sectionValue || typeof this.sectionValue !== "object") return undefined;
      // Case-insensitive lookup
      const key = this.resolveKey(this.sectionValue, name);
      return key !== undefined ? this.sectionValue[key] : undefined;
    },

    setPropertyValue(name, val) {
      const current = this.sectionValue && typeof this.sectionValue === "object"
        ? { ...this.sectionValue }
        : {};
      const key = this.resolveKey(current, name) || name;
      current[key] = val;

      const updatedConfig = { ...this.configuration };
      updatedConfig[this.configKey] = current;
      this.$emit("update:configuration", updatedConfig);
    },

    resolveKey(obj, name) {
      if (!obj || typeof obj !== "object") return undefined;
      if (name in obj) return name;
      const lower = name.toLowerCase();
      return Object.keys(obj).find(k => k.toLowerCase() === lower);
    },
  },
};
</script>

<style scoped>
.qai-section {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 20px 24px 16px;
  margin-bottom: 8px;
  transition: box-shadow 0.2s ease;
}

.qai-section:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.qai-section__accent-bar {
  width: 4px;
  min-height: 32px;
  border-radius: 4px;
  background: var(--v-primary-base, #1976D2);
  margin-right: 14px;
  flex-shrink: 0;
}

.qai-section__title {
  letter-spacing: 0.01em;
  color: #2c2c2c;
}

.qai-section__body {
  padding-top: 4px;
}
</style>
